import { ApolloClient } from '@apollo/client';

import {
  extractLoanTapeMetadata,
  LoanTapeMetadataExtractor,
} from '@finley-technologies/calc-agent';
import { Util } from '@finley-technologies/finley-types';

import {
  GetLoanTapeMetadataQueryGQLType,
  GetLoanTapeMetadataQueryVariablesGQLType,
  GetLoanTapeMetadataDocumentGQLType,
} from 'packages/tapeBuilder/requests/tapeBuilder.gql.generated';

/**
 * returns a function that returns the loan tape metadata for given loan product mechanics
 */
export const getLoanTapeMetadataExtractor = ({
  apolloClient,
  creditFacilityId,
  loanProductId,
  reportingDate,
  fileVersion,
}: {
  apolloClient: ApolloClient<object>;
  creditFacilityId: string;
  loanProductId: string;
  reportingDate: Util.FullDateStr;
  fileVersion: number;
}): LoanTapeMetadataExtractor => {
  return async () => {
    // fetch loan tape metadata
    const { data } = await apolloClient.query<
      GetLoanTapeMetadataQueryGQLType,
      GetLoanTapeMetadataQueryVariablesGQLType
    >({
      query: GetLoanTapeMetadataDocumentGQLType,
      variables: {
        creditFacilityId,
        loanProductId,
        reportingDate,
        fileVersion,
      },
    });

    // gql => calc-agent
    const loanTapeMetadata = extractLoanTapeMetadata(data.loanTapeMetadata);

    return loanTapeMetadata;
  };
};
